import EditAffiliate from './components/EditAffiliate';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router/withRouter';
import get from 'lodash/get';
import values from 'lodash/values';
import { connect } from 'react-redux';

import {
  createAffiliate,
  updateAffiliate,
  updateAffiliateStatus,
  loadAffiliates
} from '../../shared/redux/entities/actions';
import has from "lodash/has";

function mapStateToProps(state,props){
  const affiliateId = props.match.params.affiliateId,
      brandId = props.brandId;
  return {
    brandId:brandId,
    affiliateId:affiliateId,
    needsLoading:!has(state,['entities','agencies',brandId,'name']),
    isCreate:affiliateId === 'new',
    agencyId:get(state,['entities','companies',brandId,'agencyId']),
    affiliate:get(state,['entities','affiliates',affiliateId], null)
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    createAffiliate,
    updateAffiliate,
    updateAffiliateStatus,
    loadAffiliates
  },dispatch)
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(EditAffiliate));



// WEBPACK FOOTER //
// ./src/routes/EditAffiliate/index.js